const ROLE = {
    ADMIN: "ADMIN",
    SELLER: "SELLER",
    GENERAL: "GENERAL"
}

export default ROLE 
